var $ee4f74cff6d185d7$exports = {};
$ee4f74cff6d185d7$exports = {
    "collectionLabel": `\u{C81C}\u{C548}`
};


export {$ee4f74cff6d185d7$exports as default};
//# sourceMappingURL=ko-KR.module.js.map
